import React from 'react';

export const getHelpBody = (texts, key) =>
    // Necessary pending rewrite to markdown or similar
    // eslint-disable-next-line react/no-danger
    texts[key] ? <div dangerouslySetInnerHTML={{ __html: texts[key] }} /> : null;

const getLabel = (texts, key, optional = false) => {
    if (texts[key]) return `${texts[key]}${optional ? ' (Valgfritt)' : ''} `;
    return `* MANGLER tekst ${key} *`;
};

export default getLabel;
